import { render, staticRenderFns } from "./DreamToolAgreement.vue?vue&type=template&id=3c86f4e9&scoped=true"
import script from "./DreamToolAgreement.vue?vue&type=script&lang=js"
export * from "./DreamToolAgreement.vue?vue&type=script&lang=js"
import style0 from "./DreamToolAgreement.vue?vue&type=style&index=0&id=3c86f4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86f4e9",
  null
  
)

export default component.exports